<template>
  <b-card no-body class="mb-4 flex-grow-1">
    <b-card-header class="pb-1">
      <b-media no-body>
        <b-media-body>
          <h1 class="mb-0" style="cursor:pointer">
            <div class="skeleton-box" style="width: 200px;" />
          </h1>
          <small class="text-muted">
            <div class="skeleton-box" style="width: 100px;" />
          </small>
        </b-media-body>
      </b-media>
      <div class="ml-auto" v-if="withBadge">
        <div class="ml-1 skeleton-box" style="width: 50px; height: 20px;" />
        <div class="ml-1 skeleton-box" style="width: 50px; height: 20px;" />
        <div class="ml-1 skeleton-box" style="width: 50px; height: 20px;" />
      </div>
    </b-card-header>
    <b-card-body>
      <b-card-text class="mt-2">
        <div class="skeleton-box" style="width: 80%;" />
        <div class="skeleton-box" style="width: 70%;" />
        <div class="skeleton-box" style="width: 65%;" />
        <span class="text-white">.</span>
        <div class="card-link float-right">
          <div class="skeleton-box" style="width: 100px;" />
        </div>
      </b-card-text>
    </b-card-body>
</b-card>
</template>

<script>
import {
  BSpinner,
  BRow,
  BCol,
  BCard,
  BBadge,
  BCardHeader,
  BMedia,
  BMediaBody,
  BCardBody,
  BCardText,
  BCardTitle,
  BDropdown,
  BDropdownItem,
  BButton
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BSpinner,
    BRow,
    BCol,
    BCard,
    BBadge,
    BCardHeader,
    BMedia,
    BMediaBody,
    BCardBody,
    BCardText,
    BCardTitle,
    BDropdown,
    BDropdownItem,
    BButton
  },
  props: {
    withBadge: {
      type: Boolean,
      default: false
    }
  },
  directives: {
    Ripple,
  },
}
</script>

<style lang="scss" scoped>
  .skeleton-box {
  display: inline-block;
  height: 1em;
  position: relative;
  overflow: hidden;
  background-color: #DDDBDD;
  border-radius: 8px;

  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(
      90deg,
      rgba(#fff, 0) 0,
      rgba(#fff, 0.2) 20%,
      rgba(#fff, 0.5) 60%,
      rgba(#fff, 0)
    );
    animation: shimmer 2s infinite;
    content: '';
  }

  @keyframes shimmer {
    100% {
      transform: translateX(100%);
    }
  }
}

.blog-post {
  &__headline {
    font-size: 1.25em;
    font-weight: bold;
  }

  &__meta {
    font-size: 0.85em;
    color: #6b6b6b;
  }
}

// OBJECTS

.o-media {
  display: flex;
  
  &__body {
    flex-grow: 1;
    margin-left: 1em;
  }
}

.o-vertical-spacing {
  > * + * {
    margin-top: 0.75em;
  }
  
  &--l {
    > * + * {
      margin-top: 2em;
    }
  }
}

// MISC

* {
  box-sizing: border-box;
}

body {
  max-width: 42em;
  margin: 0 auto;
  padding: 3em 1em;
  font-family: 'Karla', sans-serif;
  line-height: 1.4;
}

header {
  max-width: 42em;
  margin: 0 auto;
  text-align: center;
  font-size: 1.2em;
}

main {
  margin-top: 3em;
}

header {
  h1 {
    font-family: 'Rubik', sans-serif;
    font-weight: 500;
    line-height: 1.2;
    font-size: 2em;
  }

  p {
    &:not(:first-child) {
      margin-top: 1em;
    }
  }
}
</style>